import { useEffect } from 'react';

import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { Modal, useModalContext } from '@app-velocity/ui';
import { CheckedPrimaryIcon } from '@app-velocity/icons';

const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: `${theme.spacing(3)} ${theme.spacing(5)}`,
}));

export const ReportLinkCopiedModalContent = () => {
  const { closeModal } = useModalContext();
  const { t } = useI18n();

  useEffect(() => {
    const timer = setTimeout(() => {
      closeModal();
    }, 3000);

    return () => {
      clearInterval(timer);
    };
  });

  return (
    <Modal data-testid="share-report-modal-link-copied">
      <Content>
        <CheckedPrimaryIcon />
        {t('reports:copied_to_clipboard')}
      </Content>
    </Modal>
  );
};
